import { render, staticRenderFns } from "./VLabel.vue?vue&type=template&id=107ab34a&scoped=true"
import script from "./VLabel.vue?vue&type=script&lang=js"
export * from "./VLabel.vue?vue&type=script&lang=js"
import style0 from "./VLabel.vue?vue&type=style&index=0&id=107ab34a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ab34a",
  null
  
)

export default component.exports